import SummaryView from "./SummaryView"

export default SummaryView
